(ns frontend.ui.component.lp-portal.report.company.overview.view
  (:require
   [clojure.string :as s]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.company.overview.style :as style]
   [frontend.ui.component.lp-portal.stacked-text-group.view :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.strong-label.view :refer [strong-label]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]))

(defn- overview-figures-board
  [board]
  (let [[board-label board-members] (:figures board)]
    [:div
     {:class (<class style/board)}
     [strong-label board-label]
     (map (fn [board-member]
            (let [[member-name & member-title-strs] (s/split board-member ", ")]
              [:div
               member-name
               (when member-title-strs
                 [:span
                  ", "
                  [:span
                   {:class (<class style/board-title)}
                   (s/join ", " member-title-strs)]])]))
          board-members)]))

(defn overview-card
  [{:keys [case-overview latest-development overview-figures board] :as overview}
   {:keys [edit-mode? save-text] :as props}]
  [card
   {:title ""}
   [:div
    [free-text-card/free-text-section "Case overview" case-overview props]
    [free-text-card/free-text-section "Latest development" latest-development props]]
   [:div
    (into [:div]
          (concat (map #(apply stacked-text-group %)
                       (:figures overview-figures))
                  (when board
                    [(overview-figures-board board)])))
    (text-content/optional-footnote overview-figures
                                    props)]])
